export enum AuthorizationType {
  unknown,
  copay,
  prior,
  patientAssistance
}